export function mapConfig(env: string, rootConfig: Record<string, any>) {
  const translatedEnv = (rootConfig.envMap as Record<string, any>)[env]  || rootConfig.envMap['sbx'];
  return (rootConfig as Record<string, any>)[translatedEnv];
}

export function getFirebaseConfig(env: string, rootConfig: Record<string, any>) {
  return env === 'prd'? rootConfig.firebase_prd : rootConfig.firebase_dev;
}
